import {DateDifference} from 'utilities/dates';
import {useI18n} from 'utilities/i18n';

interface Props {
  dateDiff: DateDifference | null;
}

export function ExpiryTimerHourMinute({dateDiff}: Props) {
  const {translate, formatSingularHoursAndMinutes} = useI18n();

  if (!dateDiff) return null;

  const timeRemaining = formatSingularHoursAndMinutes(dateDiff);

  return <>{translate('expiry', {countdown: timeRemaining})}</>;
}
